<template>
  <v-container fluid fill-height style="background-color: #ddd">
    <v-row align="center" justify="center">
      <v-col col="12" md="8">
        <v-card class="elevation-10 pa-5 pa-md-10 rounded-xl">
          <v-card-text>
            <iusa-logo lg />

            <h6 class="my-5">
              <v-icon color="black"> mdi-lock </v-icon>
              <strong>Restablecimiento de Contraseña</strong>
            </h6>

            <div v-if="!hasSentEmail">
              <p class="mt-5">
                Pon tu <strong>nombre de usuario de IUSA</strong> en línea o la
                dirección de <strong>correo electrónico</strong> que usaste para
                registrarte. Te enviaremos un mensaje con tu nombre de usuario y
                un enlace para restablecer tu contraseña.
              </p>

              <v-form
                ref="form"
                :disabled="isLoading"
                @submit.prevent="onSubmit"
              >
                <v-row justify="center">
                  <v-col col="12" md="8" class="text-left">
                    <v-text-field
                      v-model="username"
                      label="Usuario / Correo electrónico"
                      placeholder="Ingrese Usuario / Correo electrónico"
                      type="text"
                      autofocus
                      required
                      :rules="usernameRules"
                    />

                    <div class="d-flex justify-center">
                      <vue-recaptcha
                        v-if="!recaptchaInDevMode"
                        :sitekey="$googleSitekey"
                        @verify="onVerify"
                        @expired="onExpired"
                      />
                    </div>

                    <v-btn
                      type="submit"
                      color="#2fd410"
                      class="text-capitalize white--text mt-4"
                      rounded
                      block
                      :disabled="isLoading"
                    >
                      {{ isLoading ? 'Validando...' : 'Enviar' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>

              <help-banner class="mt-7" />
            </div>

            <div v-else>
              <p class="mt-5 text-center">
                Se te ha enviado un mensaje por
                <strong>correo electrónico</strong> con instrucciones sobre cómo
                restablecer tu contraseña.
              </p>
              <img src="img/mailing-password.svg" alt="" />
              <div class="mt-4">
                <router-link to="/" class="font-weight-bold success--text">
                  Ir a login.
                </router-link>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import HelpBanner from '@/components/HelpBanner';
  import IusaLogo from '@/components/IusaLogo';
  import recaptcha from '@/mixins/recaptcha';
  import VueRecaptcha from 'vue-recaptcha';
  import axios from 'axios';

  export default {
    name: 'PasswordReset',
    components: {
      IusaLogo,
      VueRecaptcha,
      HelpBanner,
    },
    mixins: [recaptcha],
    data() {
      return {
        username: '',
        isLoading: false,
        hasSentEmail: false,
        usernameRules: [
          (v) => !!v?.trim() || 'El usuario o correo es obligatorio',
        ],
      };
    },
    methods: {
      async onSubmit() {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.recaptchaVerified) {
          this.showError('El campo CAPTCHA es obligatorio.');
          return;
        }

        this.isLoading = true;

        try {
          await axios.post(
            `${process.env.VUE_APP_BASE_SERVER}/auth/send-email-password-recovery`,
            { username: this.username }
          );

          this.username = '';
          this.recaptcha = null;
          this.hasSentEmail = true;

          this.goHome();
        } catch ({ response }) {
          const status = response?.status;

          if (status === 400 || status === 404) {
            this.showError(response?.data?.message);
          } else {
            this.showError('Ocurrió un error al procesar tu solicitud');
          }
        }

        this.isLoading = false;
      },
      showError(msg) {
        this.$toast.error(msg, { timeout: 3000 });
      },
      goHome() {
        setTimeout(() => {
          this.$router.replace('/');
        }, 7000);
      },
    },
  };
</script>
